import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const ActionType = new ReduxAsyncAction('CSV_EXPORT');

ActionType.registerRequest(function (data) {
  const type = data.report_type;
  return dash_api
    .post(`/v1/csv-export`, data)
    .then(({ data }) => {
      return {
        type: type,
        exports: data,
      };
    })
    .catch(() => {
      return {
        type: type,
        error: true,
      };
    });
});

export const CSV_EXPORT = ActionType.constants;
export const CreateCsvExport = ActionType.request;
